import React from 'react';
import * as S from './CheckBox.Style';
import { ReactComponent as CheckIcon } from '../../../../../assets/images/habitacional/checkbox-icon.svg';

const Checkbox = ({ className, checked, text, ...props }) => (
  <S.CheckboxContainer>
    <S.HiddenCheckbox checked={checked} {...props} />
    <S.StyledCheckbox checked={checked}>
      {checked && <CheckIcon />}
    </S.StyledCheckbox>
    {text && <S.Text>{text}</S.Text>}
  </S.CheckboxContainer>
);

export default Checkbox;
